export enum TimezoneMode {
  Facility = 'facility',
  Local = 'local'
}
